import React, { useState,useEffect, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip
} from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import getAccessRights from "components/Common/getAccessRights";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCategories,
  createCategoryRequest,
  deleteCategory
} from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import Swal from 'sweetalert2';
import useButtonAccess from "components/Common/useButtonAccess";

const Category = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const { categories, loading, success, error } = useSelector((state) => state.CategoryMaster || {});
  const [authDetails, setAuthDetails] = useState(null);

  // useEffect(() => {
  //   if (loading) {
  //     dispatch(fetchCategories(authDetails?.unit_id));
  //   }
  // }, [loading, authDetails]);
  
  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
  }, [dispatch]);

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  // const location = useLocation();
  // const history = useHistory();

  useEffect(() => {
    const accessRight = getAccessRights(location.pathname,history);
  }, [location]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      categoryid: 0,
      category: "",
      description: "",
      roleid: 0,
      unitid: authDetails?.unit_id,
      createdby: authDetails?.user_id,
    },
    validationSchema: Yup.object({
      category: Yup.string()
        .required("Please Enter Category")
        .max(50, "Category must not exceed 50 characters")
        .matches(
          /^[a-zA-Z0-9 ]+$/,
          "Category allows only alphabets, numbers and spaces"
        ),

      description: Yup.string()
        .required("Description is required")
        .max(50, "Description must not exceed 50 characters")
        .matches(
          /^[a-zA-Z0-9\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]*$/,
          "Only alphanumeric and special characters are allowed"
        ),
    }),
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("category_name", values.category);
      formData.append("description", values.description);
      formData.append("cat_id", values.categoryid);
      formData.append("role_id", values.roleid);
      formData.append("unit_id", values.unitid);
      formData.append("created_by", values.createdby);

      dispatch(createCategoryRequest(formData,isEdit));
      setIsEdit(false);
      formik.resetForm();
    },
  });
  

  const handleEdit = (row) => {
    formik.setValues({
      categoryid:row.empCatgryid,
      category: row.empCategory,
      description: row.description,
      roleid: 0,
      unitid: authDetails?.unit_id,
      createdby: authDetails?.user_id,
    });
    setIsEdit(true);
    setEditId(row.id);
  };

  const handleCancel = () => {
    formik.resetForm();
    setIsEdit(false);
    setEditId(null);
  };

  // const columns = [
  //   {
  //     Header: "Action",
  //     Cell: (cellProps) => {
  //       return (
  //         <div className="d-flex gap-3">
  //           <Link
  //             to="#"
  //             className="text-success"
  //             onClick={() => handleEdit(cellProps.row.original)}
  //           >
  //             <i className="bx bxs-edit font-size-18" id="edittooltip" />
  //             <UncontrolledTooltip placement="top" target="edittooltip">
  //               Edit
  //             </UncontrolledTooltip>
  //           </Link>
  //           <Link
  //             to="#"
  //             className="text-danger"
  //             onClick={() => {
  //               handleToggleStatus(cellProps.row.original);
  //             }}
  //           >
  //             <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
  //             <UncontrolledTooltip placement="top" target="deletetooltip">
  //               Delete
  //             </UncontrolledTooltip>
  //           </Link>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     Header: "S.No",
  //     Cell: ({ row }) => categories.length - row.index,
  //           className: "serial-no",
  //     applyHeaderClass: true,
  //   },
  //   {
  //     Header: "Category",
  //     accessor: "empCategory",
  //   },
  //   {
  //     Header: "Description",
  //     accessor: "description",
  //   },
  //   {
  //     Header: "Created By",
  //     accessor: "createdby",
  //   },
  //   {
  //     Header: "Created Date",
  //     accessor: "createddate",
  //   },
    
  // ];

  const columns = useMemo(() => {

    const actionColumn = (canEdit || canDelete)
      ? {
          Header: "Action",
          Cell: (cellProps) => {
            const { id } = cellProps.row.original;  // unique id for tooltip
            return (
              <div className="d-flex gap-3">

                {canEdit && (
                  <Link
                    to="#"
                    className="text-success"
                    onClick={() => handleEdit(cellProps.row.original)}
                  >
                    <i
                      className="bx bxs-edit font-size-18"
                      id={`edit-tooltip-${id}`}
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target={`edit-tooltip-${id}`}
                    >
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                )}

                {canDelete && (
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => handleToggleStatus(cellProps.row.original)}
                  >
                    <i
                      className="mdi mdi-delete font-size-18"
                      id={`delete-tooltip-${id}`}
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target={`delete-tooltip-${id}`}
                    >
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                )}

              </div>
            );
          },
        }
      : null;

    return [
      ...(actionColumn ? [actionColumn] : []),
      {
        Header: "S.No",
        Cell: ({ row }) => categories.length - row.index,
        className: "serial-no",
        applyHeaderClass: true,
      },
      { Header: "Category", accessor: "empCategory" },
      { Header: "Description", accessor: "description" },
      { Header: "Created By", accessor: "createdby" },
      { Header: "Created Date", accessor: "createddate" },
    ];

  }, [categories, canEdit, canDelete]);


  const handleToggleStatus = (row) => {
      Swal.fire({
        title: 'Are you sure?',
        html: `You are about to delete ${row.empCategory} category`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        reverseButtons: false,
        dangerMode: true,
      }).then((result) => {
        if (result.isConfirmed) {
            const formData = new FormData();
            formData.append("category_id", row.empCatgryid);
            formData.append("unit_id", authDetails?.unit_id);
            formData.append("createdby", authDetails?.user_id);
            dispatch(deleteCategory(formData));
        }    
      });
    };  

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumbs */}
          <Breadcrumbs title="Setup" breadcrumbItem="Category" />

          {/* Input Section */}
          {(canCreate || canEdit) && (
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row className="mb-3 g-3 align-items-center">
                  <Col md="4" lg="4" xl="4">
                    <FormGroup>
                      <Label for="category">
                        Category <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="category"
                        name="category"
                        type="text"
                        maxLength={50}
                        value={formik.values.category}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.category &&
                          Boolean(formik.errors.category)
                        }
                      />
                      {formik.touched.category && formik.errors.category && (
                        <div className="text-danger">{formik.errors.category}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="5" lg="5" xl="5">
                    <FormGroup>
                      <Label for="description">
                        Description <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="description"
                        name="description"
                        type="text"
                        maxLength={100}
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.description &&
                          Boolean(formik.errors.description)
                        }
                      />
                      {formik.touched.description && formik.errors.description && (
                        <div className="text-danger">{formik.errors.description}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="3" lg="3" xl="3" className="d-flex align-items-center justify-content-end mt-4">
                    <Button type="submit" color="primary" className="btn button-save me-2">
                    <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                    </Button>
                    <Button type="button" color="secondary" onClick={handleCancel} className="btn button-cancel">
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>

                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
          )}

          {/* Table Section */}
          <Card>
            <CardBody>
              <TableContainer
                columns={columns}
                data={categories && categories?.length > 0 ? categories : []}
                isGlobalFilter={true}
                customPageSize={10}
                // className="custom-header-css"
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Category;
